export const initMoving = (
  selector: HTMLDivElement,
  messages: Array<Record<string, any>>
) => {
  const btn = selector.querySelector<HTMLButtonElement>("button")!;

  selector.style.left = "50%";
  selector.style.top = "57%";
  selector.style.transform = "translate(-50%, -50%)";

  let moveCounter = 0;

  const moveButton = () => {
    const padding = 30;

    const maxX = window.innerWidth - btn.offsetWidth - padding;
    const maxY = window.innerHeight - btn.offsetHeight - padding;
    const randomX = Math.random() * maxX;
    const randomY = Math.random() * maxY;

    selector.style.left = `${randomX}px`;
    selector.style.top = `${randomY}px`;
    selector.style.transform = "none";

    moveCounter++;
    btn.innerText = messages.find((m) => moveCounter <= m?.limit)!.text;
  };

  selector.addEventListener("mouseenter", moveButton);
  selector.addEventListener("pointerdown", (e) => {
    e.preventDefault();
    moveButton();
  });
};

export const sillyTitle = (elements: NodeListOf<HTMLElement>) => {
  const colors = [
    "text-red-500",
    "text-pink-500",
    "text-green-500",
    "text-blue-500",
    "text-purple-500"
  ];

  elements.forEach((element) => {
    element!.innerHTML = element!.textContent
      .split("")
      .map((letter, i) => {
        const char = letter === " " ? "&nbsp;" : letter;
        return `<span class="${colors[i % colors.length]} inline-block animate-bounce">${char}</span>`;
      })
      .join("");
  });
};
